import XIcon from '@/shared-components/icons/components/public/XIcon';
import GenericPopup from '@/shared-components/popups/components/GenericPopup';
import Text from '@/shared-components/text/components/Text';

export default function InfoIconArtwork({ className="", onClick=null, open=false, header=null, description=null, header2=null, description2=null }) {
  const lines = String(description ?? '').split('\n');
  const lines2 = description2 ? String(description2).split('\n') : [];

  const onXClick = (event) => {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    if (onClick) {
      onClick(false);
    }
  };

  return (
    <>
      <svg className={className} onClick={onClick}  viewBox="0 0 1100 1200" xmlns="http://www.w3.org/2000/svg">
        <path d="M512 64a448 448 0 110 896.064A448 448 0 01512 64zm67.2 275.072c33.28 0 60.288-23.104 60.288-57.344s-27.072-57.344-60.288-57.344c-33.28 0-60.16 23.104-60.16 57.344s26.88 57.344 60.16 57.344zM590.912 699.2c0-6.848 2.368-24.64 1.024-34.752l-52.608 60.544c-10.88 11.456-24.512 19.392-30.912 17.28a12.992 12.992 0 01-8.256-14.72l87.68-276.992c7.168-35.136-12.544-67.2-54.336-71.296-44.096 0-108.992 44.736-148.48 101.504 0 6.784-1.28 23.68.064 33.792l52.544-60.608c10.88-11.328 23.552-19.328 29.952-17.152a12.8 12.8 0 017.808 16.128L388.48 728.576c-10.048 32.256 8.96 63.872 55.04 71.04 67.84 0 107.904-43.648 147.456-100.416z"/>
      </svg>

      <GenericPopup open={open} className="generic-popup_content remove-scrollbar" opacity>
        <div className="generic-popup__header">
          <Text className="generic-popup__header-text-theme">
            {header}
          </Text>
                    
          <XIcon className="generic-popup__close" onClick={onXClick}/>
        </div>

        {lines.map((line, index) => (
          <p key={index} style={{ marginBottom: index === lines.length - 1 ? 0 : undefined }}>
            {line}
          </p>
        ))}

        {(header2 && description2) &&
          <>
            <div className="generic-popup__header">
              <Text className="generic-popup__header-text-theme">
                {header2}
              </Text>
            </div>

            {lines2.map((line, index) => (
              <p key={index} style={{ marginBottom: index === lines2.length - 1 ? 0 : undefined }}>
                {line}
              </p>
            ))}
          </>
        }
        
      </GenericPopup>
    </>
  );
}
